<div class="common-modal__container">
  <div class="common-modal__header">
    <span class="common-modal__text-header">
      {{exportFormat.title}}
    </span>
  </div>
  <div [ngClass]="configuration.exportToWord?'common-modal__form-container-extend-row':'common-modal__form-container-row'">
    @if (configuration.exportToWord) {
      <button class="common-button-card__container-action"
        (click)="selectFormat('docx')">
        <div class="common-button-card__title-container-action">
          <div class="common-button-card__inner-title-action"
            [afTranslate]="'export-format-modal.format-titles.word'">
            _Word
          </div>
          <i class="lf-icon-send-word common-icon__xl"></i>
        </div>
        <span  class="common-button-card__description"
          [afTranslate]="'export-format-modal.format-texts.word'">
        </span>
      </button>
    }
    <button class="common-button-card__container-action"
      (click)="selectFormat('xls')">
      <div class="common-button-card__title-container-action">
        <div class="common-button-card__inner-title-action"
          [afTranslate]="'export-format-modal.format-titles.title-1'">
          _Excel
        </div>
        <i class="lf-icon-send-excel common-icon__xl"></i>
      </div>
      <span  class="common-button-card__description"
        [afTranslate]="'export-format-modal.format-texts.text-1'">
      </span>
    </button>
    <button class="common-button-card__container-action"
      (click)="selectFormat('pdf')">
      <div class="common-button-card__title-container-action">
        <div class="common-button-card__inner-title-action"
          [afTranslate]="'export-format-modal.format-titles.title-2'">
          _Pdf
        </div>
        <i class="lf-icon-send-pdf common-icon__xl"></i>
      </div>
      <span class="common-button-card__description"
        [afTranslate]="'export-format-modal.format-texts.text-2'">
        _Los contactos seleccionados podrán acceder al concepto en modo lectura.
      </span>
    </button>
  </div>
  <div class="common-modal__footer">
      <button class="common-button__text"
        (click)="handleDismiss()">
        <span class="common-button__text-title"
          [afTranslate]="'common.close'">
        </span>
      </button>
  </div>
</div>
